import { EyeOutlined } from '@ant-design/icons';
import { Button, Select, Tag, Typography, Badge } from 'antd';
import React from 'react';

const { Title } = Typography;
const { Option } = Select;

const getStatusTag = (status) => {
    const statusColors = {
        'Complete': 'success',
        'Incomplete': 'warning',
        'Pending': 'processing',
        'On-going': 'blue',
        'Approved': 'green',
        'Rejected': 'red'
    };

    return <Tag color={statusColors[status] || 'default'}>{status}</Tag>;
};

export const columns = [
    {
        title: "Name",
        key: "name",
        width: "20%",
        render: (_, record) => `${record.firstName} ${record.lastName}`,
    },
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: "15%",
    },
    {
        title: "Mobile",
        dataIndex: "mobile",
        key: "mobile",
        width: "10%",
    },
    {
        title: "Academic Year",
        dataIndex: "academicYear",
        key: "academicYear",
        width: "10%",
    },
    {
        title: "Academic Level",
        dataIndex: "academicLevel",
        key: "academicLevel",
        width: "10%",
    },
    {
        title: "Academic Strand",
        dataIndex: "academicStrand",
        key: "academicStrand",
        width: "10%",
    },
    {
        title: "Admission Status",
        dataIndex: "admissionRequirementsStatus",
        key: "admissionRequirementsStatus",
        width: "10%",
        render: (status) => getStatusTag(status),
    },
    {
        title: "Enrollment Status",
        dataIndex: "enrollmentRequirementsStatus",
        key: "enrollmentRequirementsStatus",
        width: "10%",
        render: (status) => getStatusTag(status),
    },
    {
        title: "Requirements Status",
        key: "requirementsStatus",
        width: "10%",
        render: (_, record) => {

            const status = record.enrollmentApprovalAdminStatus;
            console.log("stasss22", status)
            if (status === 'Complete') {
                return (
                    <Badge
                        status="success"
                        text={<span style={{ color: '#52c41a', fontWeight: 'bold' }}>COMPLETE</span>}
                    />
                );
            } else if (status === 'Rejected') {
                return (
                    <Badge
                        status="error"
                        text={<span style={{ color: '#f5222d', fontWeight: 'bold' }}>REJECTED</span>}
                    />
                );
            } else {
                    // For undefined or any other value, treat as "Pending"
                return (
                    <Badge
                        status="processing"
                        text={<span style={{ color: '#1890ff', fontWeight: 'bold' }}>PENDING</span>}
                    />
                );
            }
        }
    },
    {
        title: "Actions",
        key: "actions",
        width: "10%",
        render: (_, record) => (
            <Button
                type="primary"
                icon={<EyeOutlined />}
            >
                Review Applicant
            </Button>
        ),
    },
];

export { getStatusTag };